"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT = void 0;
const Actions = __importStar(require("../actions/types"));
const const_1 = require("../const");
exports.DEFAULT = {
    categoriesMap: {},
    topLevelCategoryIds: [],
    categoryGroups: [],
    allCategories: [],
};
const categoriesSetCategories = (state, categories) => {
    categories.push({
        createdAt: null,
        id: const_1.UNCATEGORIZED_ID,
        organizationId: null,
        parentId: null,
        proprietaryId: null,
        title: 'Uncategorized',
        updatedAt: null,
    });
    const topLevelCategoryIds = categories.filter((category) => !category.parentId).map((category) => category.id);
    const categoriesMap = categories.reduce((acc, category) => {
        acc[category.id] = Object.assign(Object.assign({}, category), { subcategoryIds: [] });
        return acc;
    }, {});
    // fill subcategoryIds
    // better performance than put it in reduce
    categories.forEach((category) => {
        var _a;
        (_a = categoriesMap[category.parentId]) === null || _a === void 0 ? void 0 : _a.subcategoryIds.push(category.id);
    });
    return Object.assign(Object.assign({}, state), { topLevelCategoryIds,
        categoriesMap, allCategories: categories });
};
const categoriesSetCategoryGroups = (state, categoryGroups) => (Object.assign(Object.assign({}, state), { categoryGroups: [...categoryGroups] }));
exports.default = (state = exports.DEFAULT, action) => {
    switch (action.type) {
        case Actions.CATEGORIES_SET_CATEGORIES:
            return categoriesSetCategories(state, action.payload.categories);
        case Actions.CATEGORIES_RESET_DATA:
            return Object.assign({}, exports.DEFAULT);
        case Actions.CATEGORIES_SET_CATEGORY_GROUPS:
            return categoriesSetCategoryGroups(state, action.payload.categoryGroups);
        default:
            return state;
    }
};
